export interface Game {
  id: string;
  title: string;
  slug: string;
  category: string;
  categorySlug: string;
  image: string;
  rating: number;
  players: string;
  description: string;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
  releaseDate: string;
  playUrl: string;
  featured?: boolean;
}

export const games: Game[] = [
  {
    id: 'g1',
    title: '星露谷物语',
    slug: 'stardew-valley',
    category: '角色扮演',
    categorySlug: 'rpg',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20pixel%20art%20farm%20game%20scene%20with%20green%20fields%20and%20cute%20animals%2C%20warm%20sunlight%2C%20cozy%20rural%20atmosphere%2C%20game%20screenshot%20style%20with%20vibrant%20colors%20and%20charming%20pixel%20graphics%2C%20beautiful%20farmland%20with%20crops%20and%20a%20small%20wooden%20house&width=800&height=600&seq=game-stardew-valley&orientation=landscape',
    rating: 4.9,
    players: '128.5万',
    description: '经典农场模拟角色扮演游戏，在星露谷经营自己的农场，与村民互动，探索神秘洞穴，享受宁静的田园生活。',
    tags: ['模拟经营', '像素风格', '开放世界'],
    isHot: true,
    isNew: false,
    releaseDate: '2016-02-26',
    playUrl: '#',
    featured: true,
  },
  {
    id: 'g2',
    title: '空洞骑士',
    slug: 'hollow-knight',
    category: '动作冒险',
    categorySlug: 'action',
    image: 'https://readdy.ai/api/search-image?query=Dark%20atmospheric%20hand-drawn%202D%20game%20scene%20with%20a%20small%20knight%20character%20in%20an%20underground%20cavern%2C%20moody%20blue%20and%20black%20color%20palette%2C%20gothic%20art%20style%2C%20mysterious%20ancient%20ruins%2C%20beautiful%20hand-drawn%20game%20art&width=800&height=600&seq=game-hollow-knight&orientation=landscape',
    rating: 4.8,
    players: '96.3万',
    description: '精美的手绘风格动作冒险游戏，在庞大的地下王国中探索，面对强大的敌人，揭开古老的秘密。',
    tags: ['横版动作', '手绘风格', '类银河城'],
    isHot: true,
    isNew: false,
    releaseDate: '2017-02-24',
    playUrl: '#',
  },
  {
    id: 'g3',
    title: '蔚蓝',
    slug: 'celeste',
    category: '动作冒险',
    categorySlug: 'action',
    image: 'https://readdy.ai/api/search-image?query=Pixel%20art%20platformer%20game%20scene%20with%20a%20red-haired%20girl%20climbing%20a%20snowy%20mountain%2C%20beautiful%20sunset%20sky%2C%20challenging%20platforms%2C%20pixel%20art%20style%20with%20warm%20colors%2C%20mountain%20landscape%20with%20snow%20and%20clouds&width=800&height=600&seq=game-celeste&orientation=landscape',
    rating: 4.9,
    players: '75.8万',
    description: '挑战性十足的像素风平台跳跃游戏，帮助Madeline攀登蔚蓝山，克服内心的恐惧，体验感人至深的故事。',
    tags: ['平台跳跃', '像素风格', '剧情丰富'],
    isHot: true,
    isNew: false,
    releaseDate: '2018-01-25',
    playUrl: '#',
  },
  {
    id: 'g4',
    title: '文明帝国VI',
    slug: 'civilization-6',
    category: '策略模拟',
    categorySlug: 'strategy',
    image: 'https://readdy.ai/api/search-image?query=Strategy%20game%20map%20with%20hexagonal%20tiles%2C%20ancient%20civilizations%2C%20colorful%20world%20map%20view%2C%20empire%20building%20theme%2C%20warm%20earthy%20tones%2C%20game%20UI%20with%20city%20and%20unit%20icons%2C%20top-down%20strategic%20view&width=800&height=600&seq=game-civilization&orientation=landscape',
    rating: 4.7,
    players: '89.2万',
    description: '经典回合制策略游戏，从石器时代到未来时代，建立你的文明，通过外交、战争、科技和文化征服世界。',
    tags: ['回合制', '历史题材', '4X策略'],
    isHot: false,
    isNew: true,
    releaseDate: '2016-10-21',
    playUrl: '#',
    featured: true,
  },
  {
    id: 'g5',
    title: '死亡细胞',
    slug: 'dead-cells',
    category: '动作冒险',
    categorySlug: 'action',
    image: 'https://readdy.ai/api/search-image?query=Dark%20gothic%20pixel%20art%20action%20game%20scene%2C%20a%20flame-headed%20warrior%20fighting%20monsters%20in%20a%20dungeon%2C%20fast-paced%20combat%2C%20atmospheric%20lighting%2C%20pixel%20art%20with%20smooth%20animations%2C%20medieval%20castle%20interior&width=800&height=600&seq=game-dead-cells&orientation=landscape',
    rating: 4.8,
    players: '67.4万',
    description: 'Roguelite与银河城结合的爽快动作游戏，每一次死亡都是新的开始，在随机生成的关卡中挑战自我。',
    tags: ['Roguelite', '像素风格', '快节奏'],
    isHot: false,
    isNew: false,
    releaseDate: '2018-08-07',
    playUrl: '#',
  },
  {
    id: 'g6',
    title: '传说之下',
    slug: 'undertale',
    category: '角色扮演',
    categorySlug: 'rpg',
    image: 'https://readdy.ai/api/search-image?query=Retro%20pixel%20art%20RPG%20game%20scene%20with%20a%20child%20character%20in%20an%20underground%20world%2C%20colorful%20characters%2C%20retro%20game%20style%2C%20warm%20and%20nostalgic%20pixel%20graphics%2C%20underground%20cavern%20with%20purple%20and%20blue%20tones&width=800&height=600&seq=game-undertale&orientation=landscape',
    rating: 4.9,
    players: '112.6万',
    description: '颠覆传统的像素RPG神作，在这个充满个性的地下世界中，你可以选择战斗或和平解决一切问题。',
    tags: ['像素风格', '剧情神作', '多结局'],
    isHot: true,
    isNew: false,
    releaseDate: '2015-09-15',
    playUrl: '#',
    featured: true,
  },
  {
    id: 'g7',
    title: '王国保卫战',
    slug: 'kingdom-rush',
    category: '策略模拟',
    categorySlug: 'strategy',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20cartoon%20tower%20defense%20game%20scene%2C%20medieval%20fantasy%20theme%2C%20towers%20and%20soldiers%20defending%20a%20path%2C%20bright%20vibrant%20colors%2C%20whimsical%20art%20style%2C%20forest%20and%20castle%20setting%20with%20enemy%20waves&width=800&height=600&seq=game-kingdom-rush&orientation=landscape',
    rating: 4.6,
    players: '55.1万',
    description: '经典塔防策略游戏，建造强大的防御塔，指挥英雄和士兵，抵御一波又一波的敌人进攻。',
    tags: ['塔防', '策略', '卡通风格'],
    isHot: false,
    isNew: false,
    releaseDate: '2011-07-28',
    playUrl: '#',
  },
  {
    id: 'g8',
    title: '极乐迪斯科',
    slug: 'disco-elysium',
    category: '角色扮演',
    categorySlug: 'rpg',
    image: 'https://readdy.ai/api/search-image?query=Painterly%20isometric%20RPG%20game%20scene%2C%20a%20detective%20in%20a%20gritty%20urban%20setting%2C%20atmospheric%20lighting%20with%20warm%20tones%2C%20noir%20aesthetic%2C%20oil%20painting%20style%20game%20art%2C%20rainy%20city%20street%20with%20neon%20signs&width=800&height=600&seq=game-disco-elysium&orientation=landscape',
    rating: 4.9,
    players: '48.7万',
    description: '颠覆传统的开放世界RPG，化身为失忆警探，在充满政治角力的城市中破案，对话即是战斗。',
    tags: ['侦探', '开放世界', '叙事驱动'],
    isHot: false,
    isNew: true,
    releaseDate: '2019-10-15',
    playUrl: '#',
  },
  {
    id: 'g9',
    title: '植物大战僵尸',
    slug: 'plants-vs-zombies',
    category: '策略模拟',
    categorySlug: 'strategy',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20casual%20tower%20defense%20game%20scene%20with%20cute%20plants%20fighting%20cartoon%20zombies%20in%20a%20garden%2C%20bright%20green%20lawn%2C%20sunny%20daylight%2C%20whimsical%20and%20fun%20art%20style%2C%20family-friendly%20game%20graphics&width=800&height=600&seq=game-pvz&orientation=landscape',
    rating: 4.5,
    players: '230.4万',
    description: '风靡全球的经典塔防游戏，用各种有趣的植物抵御僵尸的进攻，策略与趣味完美结合。',
    tags: ['塔防', '休闲', '经典'],
    isHot: false,
    isNew: false,
    releaseDate: '2009-05-05',
    playUrl: '#',
  },
  {
    id: 'g10',
    title: '茶杯头',
    slug: 'cuphead',
    category: '动作冒险',
    categorySlug: 'action',
    image: 'https://readdy.ai/api/search-image?query=1930s%20rubber%20hose%20animation%20style%20game%20scene%2C%20a%20cup-headed%20character%20fighting%20a%20boss%2C%20vintage%20cartoon%20aesthetic%2C%20hand-drawn%20animation%20look%2C%20warm%20sepia%20and%20vibrant%20color%20palette%2C%20retro%20cartoon%20background&width=800&height=600&seq=game-cuphead&orientation=landscape',
    rating: 4.7,
    players: '42.3万',
    description: '致敬1930年代卡通风格的动作神作，手绘动画精美绝伦，BOSS战设计巧妙，难度与艺术并存。',
    tags: ['手绘风格', '高难度', 'Boss战'],
    isHot: false,
    isNew: false,
    releaseDate: '2017-09-29',
    playUrl: '#',
  },
  {
    id: 'g11',
    title: '泰拉瑞亚',
    slug: 'terraria',
    category: '动作冒险',
    categorySlug: 'action',
    image: 'https://readdy.ai/api/search-image?query=2D%20pixel%20art%20sandbox%20game%20scene%2C%20underground%20mining%20with%20colorful%20ores%20and%20monsters%2C%20building%20and%20exploration%2C%20vibrant%20pixel%20graphics%2C%20adventure%20theme%20with%20caves%20and%20treasures%2C%20retro%20game%20aesthetic&width=800&height=600&seq=game-terraria&orientation=landscape',
    rating: 4.8,
    players: '156.2万',
    description: '2D沙盒冒险游戏的巅峰之作，挖掘、建造、战斗、探索，无限的可能性等你来发现。',
    tags: ['沙盒', '像素风格', '多人合作'],
    isHot: true,
    isNew: false,
    releaseDate: '2011-05-16',
    playUrl: '#',
    featured: true,
  },
  {
    id: 'g12',
    title: '冰汽时代',
    slug: 'frostpunk',
    category: '策略模拟',
    categorySlug: 'strategy',
    image: 'https://readdy.ai/api/search-image?query=Dark%20atmospheric%20steampunk%20city%20survival%20game%20scene%2C%20a%20giant%20generator%20in%20the%20center%20of%20a%20frozen%20city%2C%20snow%20and%20ice%20everywhere%2C%20industrial%20revolution%20aesthetic%2C%20dramatic%20lighting%2C%20survival%20theme%20with%20warm%20glow%20from%20the%20generator&width=800&height=600&seq=game-frostpunk&orientation=landscape',
    rating: 4.6,
    players: '38.9万',
    description: '末日冰河时代的城市生存策略游戏，作为最后的城市领袖，在极端环境中做出艰难的道德抉择。',
    tags: ['生存', '策略', '蒸汽朋克'],
    isHot: false,
    isNew: true,
    releaseDate: '2018-04-24',
    playUrl: '#',
  },
];